import React, { useContext, useMemo } from "react"
import { StyledComponent } from "@rogue_4/types"
import classNames from "classnames"

import { ESubPage, GlobalContext } from "@/topic/rogue_4/context"
import AddressModal from "./AddressModal"
import BackpackModal from "./BackpackModal"
import CraftModal from "./CraftModal"
import EffectModal from "./EffectModal"
import EquipModal from "./EquipModal"
import GalleryModal from "./GalleryModal"
import HistoryModal from "./HistoryModal"
import ItemModal from "./ItemModal"
import RestartModal from "./RestartModal"
import RollModal from "./RollModal"
import RuleModal from "./RuleModal"
import ShareModal from "./ShareModal"
import UseItemModal from "./UseItemModal"

import styles from "./index.module.less"

const ModalContainer: StyledComponent = ({ className, style }) => {
    const {
        state: { currentSubPage },
    } = useContext(GlobalContext)

    const modalStyles = useMemo<React.CSSProperties>(() => {
        if (currentSubPage !== ESubPage.Game) {
            return { pointerEvents: "none" }
        }

        return {}
    }, [currentSubPage])

    return (
        <div
            className={classNames(styles.modalContainer, className)}
            style={style}
        >
            <UseItemModal style={modalStyles} />
            <BackpackModal style={modalStyles} />
            <ItemModal style={modalStyles} />
            <EquipModal style={modalStyles} />
            <GalleryModal style={modalStyles} />
            <CraftModal style={modalStyles} />
            <HistoryModal style={modalStyles} />
            <ShareModal style={modalStyles} />
            <RollModal style={modalStyles} />
            <RuleModal style={modalStyles} />
            <AddressModal style={modalStyles} />
            <EffectModal style={modalStyles} />
            <RestartModal style={modalStyles} />
        </div>
    )
}

export default ModalContainer
